import { useEffect, useState } from 'react'

import { Button, Card } from '../../components'
import { PoolsTable } from '../../components/pools-table'
import { AddAccountPaths } from '../../config/routes'
import RewardsIcon from './rewards.png'

export function DataFarmingTable() {
    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const enfasisClasses = ' text-black '
    const [bankTransactionsAmount, setbankTransactionsAmount] = useState(
        localStorage.getItem('bank_transactions'),
    )
    const [cryptoTransactionsAmount, setcryptoTransactionsAmount] = useState(
        localStorage.getItem('crypto_transactions'),
    )
    const [bankRewards, setbankRewards] = useState(
        localStorage.getItem('bank_reward_points'),
    )
    const [cryptoRewards, setcryptoRewards] = useState(
        localStorage.getItem('crypto_reward_points'),
    )

    const [cryptoAccounts, setcryptoAccounts] = useState(
        localStorage.getItem('crypto_accounts'),
    )
    const [bankAccounts, setbankAccounts] = useState(
        localStorage.getItem('bank_accounts'),
    )

    useEffect(() => {
        window.addEventListener('storage', function () {
            setbankTransactionsAmount(localStorage.getItem('bank_transactions'))
            setcryptoTransactionsAmount(
                localStorage.getItem('crypto_transactions'),
            )
            setbankRewards(localStorage.getItem('bank_reward_points'))
            setcryptoRewards(localStorage.getItem('crypto_reward_points'))

            setcryptoAccounts(localStorage.getItem('crypto_accounts'))
            setbankAccounts(localStorage.getItem('bank_accounts'))
        })
    }, [])

    if (!cryptoRewards && !bankRewards) {
        return (
            <>
                <div className='flex flex-col justify-center items-center mt-12'>
                    <h2>You dont have rewards yet...</h2>
                    <img src={RewardsIcon} className='w-18' alt='empty state' />

                    <Button
                        className='mt-8'
                        onClick={() => window.location.reload()}>
                        Reload page!
                    </Button>
                </div>
            </>
        )
    }
    return (
        <>
            <div className='grid grid-cols-8 pt-12'>
                <div className='col-span-8'>
                    <Card className='w-full h-full py-8'>
                        <div className='flex flex-row justify-between'>
                            <h3>Rewards history</h3>
                        </div>
                        <PoolsTable
                            headers={[
                                'Connected Data Source',
                                'Number of accounts',
                                'Number of transactions',
                                'Points',
                            ]}
                            items={
                                <>
                                    <tr
                                        className='border-b border-gray border-solid border-opacity-10 group'
                                        data-test-id={`transaction-item`}>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='font-normal text-left w-full'>
                                                    Bank
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {bankAccounts}
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {bankTransactionsAmount}
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {bankRewards}
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        className='border-b border-black border-solid group'
                                        data-test-id={`transaction-item`}>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='font-normal text-left w-full'>
                                                    Crypto
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {cryptoAccounts}
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {cryptoTransactionsAmount}
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {cryptoRewards}
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        className=' group'
                                        data-test-id={`transaction-item`}>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-semibold text-left w-full'>
                                                    Total Rewards
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'></p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'></p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-bold text-left w-full'>
                                                    {parseInt(
                                                        bankRewards ?? '',
                                                    ) +
                                                        parseInt(
                                                            cryptoRewards ?? '',
                                                        )}{' '}
                                                    CORN
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                        />
                    </Card>
                </div>
            </div>
            <a href={AddAccountPaths.ADD_ACCOUNT}>
                <button
                    className='mt-16 h-16 py-2 px-5 mr-3 rounded-sm bg-black text-white w-1/6'
                    type='button'>
                    + Connect Accounts
                </button>
            </a>
        </>
    )
}
